// Users with these phone numbers can only access the MF section.
export const MF_ONLY_PHONES: (string | undefined)[] = ["1111111111"];
